import { useEffect, useState } from 'react'
import { kernel } from '@omni/kernel'
import { offHintFor } from '../off-hint'

const trace = (step, data) => window.__omni?.services?.getNow?.('omni.dev-logs')?.channel?.('off-hint')?.trace?.(step, data)

// One line at the bottom of the board, once per plugin: "Video graph is
// switched off, so this video draws no dots. [Turn on]" (see off-hint.js).
export function OffHint() {
  const [hint, setHint] = useState(null)
  useEffect(() => {
    const onMessage = (ev) => {
      const h = offHintFor(ev?.data, kernel.store, localStorage)
      if (!h) return
      trace('shown', h)
      setHint(h)
    }
    window.addEventListener('message', onMessage)
    return () => window.removeEventListener('message', onMessage)
  }, [])
  if (!hint) return null
  const turnOn = async () => {
    trace('turn on', hint)
    setHint(null)
    await kernel.setEnabled(hint.id, true)
  }
  return (
    <div data-test="off-hint" className="alert bg-base-100 border-base-300 text-base-content fixed bottom-4 left-1/2 z-50 w-auto -translate-x-1/2 shadow-lg">
      <span className="text-sm">
        <b>{hint.name}</b> is switched off, so {hint.what}.
      </span>
      <button data-test="off-hint-on" className="btn btn-primary btn-sm" onClick={turnOn}>
        Turn on
      </button>
      <button data-test="off-hint-close" className="btn btn-ghost btn-sm" aria-label="Close" onClick={() => setHint(null)}>
        ✕
      </button>
    </div>
  )
}
